import React from "react";
import { useNavigate } from "react-router-dom";

export default function CallToAction() {
  const navigate = useNavigate();

  const handleGetInTouch = () => {
    navigate('/contact');
  };

  return (
    <section id="call-to-action">
      <div className="container">
        <div className="columns">
          <div className="column">
            <h6>LET'S CHAT</h6>
            <h1 className="big-title transparent-effect">ABOUT YOUR</h1>
            <h1 className="big-title">
              <span className="color">NEXT PROJECT</span><span className="transparent-effect">.</span>
            </h1>
          </div>
          <div className="column action-button">
            <button className="button-touch" onClick={handleGetInTouch}>Get In Touch</button>
          </div>
        </div>
      </div>
    </section>
  )
}